<template>
  <div class="numerotation-pattern">
    <div
      v-for="(slice, index) in pattern"
      :key="slice.id"
      :class="[
        `numerotation-pattern--slice m-right-5 is-centered is-aligned-vertical`
      ]"
    >
      <div class="numerotation-pattern--slice-value is-aligned">
        <h1 v-if="!isCustom(slice)">
          {{ numerotation.formatSlice(slice) }}
        </h1>

        <f-input
          v-if="isCustom(slice)" 
          v-model="slice.format"
          class="max-width-70"
        ></f-input>
      </div>

      <div class="numerotation-pattern--slice-options is-aligned m-top-5">
        <f-button
          @click="moveLeft(index)"
          :disabled="index === 0"
          size="small"
          circle
        >
          <i class="uil uil-angle-left"></i>
        </f-button>

        <f-button
          @click="removeFromInvoiceNumerotation(index)"
          size="small"
          circle
        >
          <i class="color-danger uil uil-trash"></i>
        </f-button>

        <f-button
          @click="moveRight(index)"
          :disabled="index === pattern.length - 1"
          size="small"
          circle
        >
          <i class="uil uil-angle-right"></i>
        </f-button>
      </div>
    </div>
  </div>  
</template>

<script>
  import { ref, watch, markRaw, toRaw, shallowRef, reactive, toRefs, computed } from 'vue'
  import Constants from '@constants'

  export default {
    props: {
      modelValue: {
        type: Array,
        required: true,
      },
    },

    setup (props, context) {
      const state = reactive({
        pattern: [...props.modelValue],
      })

      function removeFromInvoiceNumerotation (index) {
        state.pattern.splice(index, 1)

        // context.emit('update:modelValue', state.pattern)
      }

      function moveLeft (index) {
        const current = state.pattern[index]
        const previous = state.pattern[index - 1]
        
        state.pattern.splice(index - 1, 1, current)
        state.pattern.splice(index, 1, previous)

        // context.emit('update:modelValue', state.pattern)
      }

      function moveRight (index) {
        const current = state.pattern[index]
        const next = state.pattern[index + 1]
        
        state.pattern.splice(index + 1, 1, current)
        state.pattern.splice(index, 1, next)

        // context.emit('update:modelValue', state.pattern)
      }

      function isCustom (slice) {
        return slice.type === 'custom'
      }

      watch(() => props.modelValue, newValue => {
        if (newValue.length < state.pattern.length) {
          state.pattern.splice(newValue.length)
        }

        for (let i = 0; i < newValue.length; i++) {
          if (state.pattern[i] && state.pattern[i].id !== newValue[i].id) {
            state.pattern.splice(i, 1, { ...newValue[i] })
          } else if (!state.pattern[i]) {
            state.pattern.push({ ...newValue[i] })
          }
        }
      }, { deep: true })

      watch(() => state.pattern, newValue => {
        context.emit('update:modelValue', newValue.map(item => ({ ...item })))
      }, { deep: true })

      return {
        ...toRefs(state),
        removeFromInvoiceNumerotation,
        moveLeft,
        moveRight,
        isCustom,
        numerotation: Constants.numerotation,
      }
    },
  }
</script>

<style lang="scss">
  .numerotation-pattern {
    position: relative;
    display: flex;
    align-items: center;

    &--slice {
      position: relative;

      &-options {
        // position: absolute;
        // top: 100%;
        // left: 50%;
        // transform: translate3d(-50%, 5px, 0);
      }
    }
  }
</style>